import { useContext } from 'react';
import { generatePath } from 'react-router-dom';

import { Navigate } from '@sorare/routing';

import { MLB_MY_CARDS_VAULT_TYPE } from '@sorare/core/src/constants/__generated__/routes';

import { MyCardsLayoutContext } from '@sorare/gameplay/src/layouts/my-cards/MyCardsLayout/MyCardsLayoutContext';

const MLBMyCardsVaultPage = () => {
  const { defaultRarity } = useContext(MyCardsLayoutContext);
  return (
    <Navigate
      to={generatePath(MLB_MY_CARDS_VAULT_TYPE, {
        type: defaultRarity,
      })}
    />
  );
};

export default MLBMyCardsVaultPage;
